<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('exchangeRate.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('exchangeRate.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button outline color="info" @click.prevent="addNew">{{
            $t('add_new')
          }}</ts-button>
          <!-- <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
          </div> -->
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template v-slot="{ record }">
          <td>{{ record.dates }}</td>
          <td>{{ record.fromC }}</td>
          <td>{{ record.toC }}</td>
          <td>{{ record.fx_rate }}</td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <!-- form-action -->
      <a-modal
        v-if="showForm"
        v-model="showForm"
        :title="$t('exchangeRate.pageTitle')"
        centered
        @cancel="clearEdit"
        :zIndex="1020"
        :footer="null"
        width="400px"
      >
        <from-action
          @cancel="clearEdit"
          @fetchData="fetchData"
        />
      </a-modal>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import FromAction from './form'

export default {
  name: 'exchangeRateIndex',
  components: {
    FromAction
  },
  data() {
    return {
      loading: false,
      showForm: false
    }
  },
  computed: {
    ...mapState('exchangeRate/currencyRate', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.exchangeRate.currencyRate.search
      },
      set(newValue) {
        this.$store.commit('exchangeRate/currencyRate/SET_SEARCH', newValue)
        this.$store.commit('exchangeRate/currencyRate/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('exchangeRate.date') },
        { name: this.$t('exchangeRate.fromCurrency') },
        { name: this.$t('exchangeRate.toCurrency') },
        { name: this.$t('exchangeRate.fxRate'), style: 'width: 10px'}
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('exchangeRate/currencyRate/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.showForm = true
    },
    clearEdit(){
       this.$store.commit('exchangeRate/currencyRate/SET_EDIT_DATA', {})
      this.showForm = false
		}
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('exchangeRate/currencyRate/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
